<div *ngIf="!isEdited" class="cell-view gap-2">
  <div class="inner-view" [title]="getDisplayValue()">
    {{ getDisplayValue() }}
  </div>

  <div *ngIf="editable" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="MultiselectCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit()"
    ></button>

    <button
      pButton
      *ngIf="!mandatory && value?.length > 0"
      id="cancelRowSelection"
      data-cy="MultiselectCell_Button_delete"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
</div>

<div *ngIf="isEdited" class="multiselect-edit-container">
  <p-multiSelect
    #multiselect
    [placeholder]="''"
    [optionLabel]="'name'"
    [options]="options"
    [(ngModel)]="selectedEntries"
    [style]="{ width: '100%' }"
    appendTo="body"
    emptyMessage="Kein Eintrag vorhanden"
    dataKey="id"
    [maxSelectedLabels]="0"
    [selectedItemsLabel]="'{0} Elemente'"
    [showClear]="false"
    (onPanelHide)="onPanelClose()"
  >
    <ng-template let-option pTemplate="item">
      <div class="flex align-items-center gap-2">
        <i *ngIf="showIcon && !!option?.icon" [class]="option.icon" [style.color]="option?.color"></i>
        <span *ngIf="showLabel">{{ option.name }}</span>
      </div>
    </ng-template>

    <ng-template let-option pTemplate="selectedItem">
      <div class="flex align-items-center gap-1">
        <i *ngIf="showIcon && !!option?.icon" [class]="option.icon" [style.color]="option?.color"></i>
        <span *ngIf="showLabel">{{ option.name }}</span>
      </div>
    </ng-template>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-end p-2 border-top-1 surface-border">
        <button pButton type="button" icon="pi pi-check" (click)="saveAndClose()"></button>
      </div>
    </ng-template>
  </p-multiSelect>
</div>
